/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.drawsParticipations.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * A participation entry in a business draw.
 */
@ExperimentalJsExport
@JsExport
@Serializable
data class ParticipationModel(
    /** Unique participation id. */
    @SerialName("id")
    val id: Int?,

    /** Start date of the participation period. */
    @SerialName("start_date")
    val startDate: String?,

    /** End date of the participation period. */
    @SerialName("end_date")
    val endDate: String?,

    /** Deadline to claim prize. */
    @SerialName("prize_claim_deadline")
    val prizeClaimDeadline: String?,

    /** Associated draw rule id. */
    @SerialName("draw_rule_id")
    val drawRuleId: Int?,

    /** Required visits count for participation. */
    @SerialName("visits_count")
    val visitsCount: Int?,

    /** Localized title/description for the draw. */
    @SerialName("draw_languages")
    val drawLanguages: List<DrawLanguages>?,

    /** List of branch ids where this participation is available. */
    @SerialName("available_at_branches")
    val availableAtBranches: List<String>?,

    /** Participation images in thumbnail/medium/large sizes. */
    @SerialName("images")
    val images: List<ImageModel>?,

    /** Participation creation date. */
    @SerialName("created_at")
    val createdAt: String?,

    /** Participation last update date. */
    @SerialName("updated_at")
    val updatedAt: String?,

    /** Number of participations. */
    @SerialName("participation_count")
    val participationCount: Int?
) : Model()
